"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodSubTypeGroups = _interopRequireDefault(require("../constants/GoodSubTypeGroups"));

var _react = _interopRequireWildcard(require("react"));

var _UINestedNav = _interopRequireDefault(require("UIComponents/nav/UINestedNav"));

var _UINestedNavItem = _interopRequireDefault(require("UIComponents/nav/UINestedNavItem"));

var _langUtils = require("../utils/langUtils");

var _sidebarUtils = require("../utils/sidebarUtils");

var _default = _react.default.createClass({
  displayName: "CategoryDropdown",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    categoryFilter: _react.PropTypes.string.isRequired,
    onGoodFilterChange: _react.PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      isTemplateMenuOpen: false
    };
  },
  getGoodFilterChangeHandlerForCategory: function getGoodFilterChangeHandlerForCategory(category) {
    var params = {};
    params[_GoodFiltersAndPage.default.SUB_TYPE] = category;
    return this.props.onGoodFilterChange(params);
  },
  toggleMenuDisplay: function toggleMenuDisplay() {
    this.setState({
      isTemplateMenuOpen: !this.state.isTemplateMenuOpen
    });
  },
  handleParentClick: function handleParentClick(item, e) {
    var isTemplateMenuOpen = this.state.isTemplateMenuOpen;

    if (item === _GoodSubTypeGroups.default.TEMPLATES) {
      if (e.target.innerText === 'down') {
        this.toggleMenuDisplay();
      } else {
        this.getGoodFilterChangeHandlerForCategory(item);

        if (!isTemplateMenuOpen) {
          this.toggleMenuDisplay();
        }
      }
    } else {
      this.getGoodFilterChangeHandlerForCategory(item);
    }
  },
  renderItem: function renderItem(item, chevron) {
    return _react.default.createElement(_UINestedNavItem.default, {
      className: "integrate-category-" + item,
      value: item,
      key: item,
      title: (0, _langUtils.getCategoryOptionText)(item),
      onClick: this.partial(this.getGoodFilterChangeHandlerForCategory, item),
      iconRight: chevron ? 'right' : null
    });
  },
  renderOption: function renderOption(_ref) {
    var _this = this;

    var item = _ref.item,
        subMenu = _ref.subMenu,
        chevron = _ref.chevron;
    var isTemplateMenuOpen = this.state.isTemplateMenuOpen;

    if (subMenu) {
      return _react.default.createElement(_UINestedNavItem.default, {
        defaultOpen: true,
        key: item,
        value: item,
        title: (0, _langUtils.getCategoryOptionText)(item),
        open: isTemplateMenuOpen,
        onClick: this.partial(this.handleParentClick, item),
        iconRight: chevron ? 'right' : null
      }, subMenu.map(function (option) {
        return _this.renderOption(option);
      }));
    }

    return this.renderItem(item, chevron);
  },
  render: function render() {
    var _this2 = this;

    var categoryFilter = this.props.categoryFilter;
    return _react.default.createElement("div", {
      className: "dropdown-container integrate-category-menu"
    }, _react.default.createElement(_UINestedNav.default, {
      value: categoryFilter,
      className: "m-bottom-0"
    }, (0, _sidebarUtils.getCategoryMenuOptions)(categoryFilter).map(function (option) {
      return _this2.renderOption(option);
    })));
  }
});

exports.default = _default;
module.exports = exports.default;